import React from 'react';
import { FaFish } from 'react-icons/fa';
import { FiCalendar, FiLock, FiUnlock, FiUserCheck, FiUsers, FiUser } from 'react-icons/fi';
import { GiFishingHook } from 'react-icons/gi';
import nextIcon from '../../assets/img/blog/next-icon.png';
import Link from "react-router-dom/Link";
import { Badge } from "react-bootstrap";

function TournamentItem(props) {

	return (

		<div className={ props.isDetail ? 'tournament-item tournament-detail' : "tournament-item" }>

			{ !props.isDetail ?
				props.status === 'Ongoing' ?
					<div className="ribbon ribbon-bookmark ribbon-primary">{props.status}</div>
					: props.status === 'Finish' ?
						<div className="ribbon ribbon-bookmark ribbon-dark">{props.status}</div>
						: props.status === 'Waiting' ?
							<div className="ribbon ribbon-bookmark ribbon-danger">{props.status}</div>
							: <div className="ribbon ribbon-bookmark ribbon-primary">{props.status}</div>
			:''}

			<figure>
				{ !props.isDetail ?
				<Link to={{
					pathname: '/tournament/'+props.id,
					state: props
				}}> <img className=" img-fluid " src={props.imgUrl} alt="" /> </Link>
					: '' }

			</figure>

			<div className={'tournament-meta'} style={props.isDetail ? {padding: '0px'} : {padding: '20px'}}>
				{!props.isDetail ?
					<h4 style={{marginBottom: '5px'}}>
					<Link to={{
						pathname: '/tournament/'+props.id,
						state: props
					}}> {props.tn_public_type === 'Private' ? <span style={{color:'#007bff'}}> <FiLock/></span> :
						props.tn_public_type === 'Publick' ? <span style={{color:'#007bff'}}> <FiUnlock /></span> :
							<span style={{color:'#007bff'}}><FiUserCheck /></span>
					} {props.title} </Link></h4>
					: ''
				}

			{/*{props.tn_public_type === 'Public' ?*/}
			{/*	<Badge pill variant="primary">*/}
			{/*		{props.tn_public_type}*/}
			{/*	</Badge> : ''*/}
			{/*}{' '}*/}
			{/*{props.tn_public_type === 'Private' ?*/}
			{/*	<Badge pill variant="secondary">*/}
			{/*		{props.tn_public_type}*/}
			{/*	</Badge> : ''*/}
			{/*}{' '}*/}
			{/*{props.tn_public_type === 'Conditional' ?*/}
			{/*	<Badge pill variant="dark">*/}
			{/*		{props.tn_public_type}*/}
			{/*	</Badge> : ''*/}
			{/*}{' '}*/}
			<Badge pill variant="warning">
				{props.tn_type ? props.tn_type : 'any'}
			</Badge>{' '}

			<div className="post-box mb-25">
				<div className="d-flex">
					<div className="post-meta">
						{/*{!props.isDetail ?*/}
						{/*<div className="meta-head">*/}
						{/*		{props.owner}*/}
						{/*</div>*/}
						{/*	: '' }*/}
						<div className="meta-details">
							<ul>
								{!props.isDetail ?
								<li>
										<FiUser className="mr-10" />
										{props.owner}
								</li>
									: ''}
								<li>
										<FiCalendar className="mr-10" />
										{props.date}
								</li>
								<li>
										<FaFish className="mr-10" />
										{props.tn_fish}
								</li>
								<li>
										<FiUsers className="mr-10" />
										{props.tn_members}
								</li>
								<li>
										<GiFishingHook className="mr-10" />
										{props.catchCount}
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			{props.isDetail ? '' :
				<Link className="blog-btn text-uppercase mt-15" to={{
					pathname: '/tournament/'+props.id,
					state: props
				}}> <span>continue Reading</span> <img src={nextIcon} alt=""/>
				</Link>
			}
		</div>
		</div>
	);
}

export default TournamentItem;
